import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["container"];
  static values = {
    uuid: String,
    index: Number,
    group: String,
    type: String
  };

  connect() {}

  addCondition(event) {
    event.preventDefault();
    let index = this.containerTarget.children.length;

    fetch(
      `/user_integrations/${this.uuidValue}/add_condition?index=${index}&type=${this.typeValue}&group_index=${this.groupValue}`,
      {
        method: "GET",
        headers: {
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')
            .content,
          Accept: "text/vnd.turbo-stream.html",
        },
      },
    )
      .then((response) => response.text())
      .then((html) => Turbo.renderStreamMessage(html));
  }

  removeCondition(event) {
    event.preventDefault();

    let index = this.indexValue;
    fetch(
      `/user_integrations/${this.uuidValue}/remove_condition?index=${index}&type=${this.typeValue}&group_index=${this.groupValue}`,
      {
        method: "DELETE",
        headers: {
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')
            .content,
          Accept: "text/vnd.turbo-stream.html",
        },
      },
    )
      .then((response) => response.text())
      .then((html) => Turbo.renderStreamMessage(html));
  }
}
